import { isProduction } from "core/env";

export const track = conversionId => {
  if (isProduction()) {
    const img = window.document.createElement("img");

    img.src = `https://dc.ads.linkedin.com/collect/?pid=254666&conversionId=${conversionId}&fmt=gif`;
  }
};



// WEBPACK FOOTER //
// ./src/core/integrations/linkedin-pixel/index.js